document.addEventListener("DOMContentLoaded", function () {
  const printBtn = document.querySelector("[id^='printall-']");
  if (!printBtn) return;

  printBtn.addEventListener("click", async function (e) {
    e.preventDefault();

    // 1. Find all blog links on the collection page
    const links = [...document.querySelectorAll(".blog-card a, .article-card a, a.blog-link")]
      .map(a => a.href)
      .filter(href => href && href.includes("/blogs/"));

    if (links.length === 0) {
      alert("No blog links found on this page.");
      return;
    }

    // 2. Fetch the full HTML of each blog post
    let allArticlesHTML = "";

    for (const url of links) {
      try {
        const response = await fetch(url);
        const html = await response.text();

        // Convert to DOM
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");

        // 3. Extract ONLY the article content - exclude headers/footers/related content
        let articleContent = 
          doc.querySelector("article") ||
          doc.querySelector(".article-template") ||
          doc.querySelector(".rte") ||
          doc.querySelector(".blog-content") ||
          doc.querySelector(".article-content") ||
          doc.querySelector(".main-content") ||
          doc.querySelector("main") ||
          doc.body.querySelector(".content") ||
          doc.body.querySelector("[class*='content']") ||
          null;

        // Fallback: if no specific content found, clean the body
        if (!articleContent) {
          articleContent = doc.body;
        }

        // Clean up the content for printing - REMOVE "You may also like" and similar sections
        if (articleContent) {
          // Remove common header/footer elements
          const headersToRemove = articleContent.querySelectorAll("header, nav, footer, .header, .navbar, .site-header, .site-footer");
          headersToRemove.forEach(el => el.remove());
          
          // Remove sidebar elements
          const sidebars = articleContent.querySelectorAll("[class*='sidebar'], .aside, .page-width-desktop, .recipe-buttons");
          sidebars.forEach(el => el.remove());

          // Remove "You may also like" / related content / recommendations
          const relatedContent = articleContent.querySelectorAll(
            '[class*="related"], [class*="also"], [class*="recommend"], [class*="upsell"], [class*="you-may"]',
            '.related-articles, .you-may-also-like, .recommended-recipes',
            'a[href*="blogs/free-recipes"]',  // Links back to collection
            '[class*="print-all"]',           // Print all buttons
            '.pagination'                     // Pagination like "1/of3"
          );
          relatedContent.forEach(el => el.remove());

          // Remove script and style tags
          const scripts = articleContent.querySelectorAll("script, style");
          scripts.forEach(el => el.remove());
          
          // Remove any remaining links to collection pages
          const collectionLinks = articleContent.querySelectorAll('a[href*="blogs/free-recipes"]');
          collectionLinks.forEach(el => el.remove());
        }

        // Add print-friendly title only if content exists
        if (articleContent && articleContent.innerHTML.trim()) {
          const title = doc.querySelector("title")?.textContent || "Recipe";
          articleContent.insertAdjacentHTML("afterbegin", `<h2 style="color: #333; border-bottom: 2px solid #ccc; padding-bottom: 10px; margin-bottom: 20px;">${title}</h2>`);
        }

        allArticlesHTML += `
          <div class="print-article" style="page-break-after: always; margin: 0 20px;">
            ${articleContent ? articleContent.innerHTML : '<p>Content not found</p>'}
          </div>
        `;
      } catch (err) {
        console.error("Error loading:", url, err);
      }
    }

    // 4. Open print window with improved print styles
    const printWindow = window.open("", "", "width=800,height=900");
    printWindow.document.write(`
      <html>
        <head>
          <title>Print All Recipes</title>
          <style>
            @media print {
              body { margin: 0; padding: 0; font-size: 12pt; }
              .print-article { page-break-after: always; margin: 20px 0; }
              img {
                max-width: 600px;
                width: 100%;
                height: auto;
                page-break-inside: avoid;
              }
              h1, h2, h3 { page-break-after: avoid; }
            }
            @media screen {
              body { font-family: Arial, sans-serif; padding: 20px; max-width: 800px; margin: 0 auto; }
              img {
                max-width: 600px;
                width: 100%;
                height: auto;
              }
              .print-article { margin-bottom: 40px; border-bottom: 1px solid #eee; padding-bottom: 20px; }
            }
            * { box-sizing: border-box; }
            body { line-height: 1.6; color: #333; }
          </style>
        </head>
        <body>
          <h1 style="text-align: center; margin-bottom: 30px; color: #2c5aa0;">All Recipes</h1>
          ${allArticlesHTML}
        </body>
      </html>
    `);
    printWindow.document.close();

    printWindow.onload = function () {
      printWindow.print();
    };
  });
});
